import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-dashboard',
    imports: [CommonModule],
    template: `
    <div class="page-container">
      <h1>Dashboard</h1>
    </div>
  `,
    styles: [`
    .page-container {
      padding: 2rem;
      max-width: 1200px;
      margin: 0 auto;
    }
    
    h1 {
      color: #1f2937;
      margin-bottom: 1rem;
    }
    
    p {
      color: #6b7280;
      line-height: 1.6;
    }
  `]
})
export class DashboardComponent {}